module.exports = __webpack_public_path__ + "img/Throwing.e105b5bb.png";